<script setup>
import { ref, onMounted } from "vue";
import { useAuthStore } from "@/stores/auth";
import { useFlashMessages } from "../composables/useFlashMessages";
import GlobalToast from "@/vue/components/GlobalToast.vue";
import BarraLateral from "@/vue/components/BarraLateral.vue";
import MenuLateral from "@/vue/components/MenuLateral.vue";
import BarraSuperior from "@/vue/components/BarraSuperior.vue";

const authStore = useAuthStore();

useFlashMessages();

const barraSuperiorHeight = ref('60px');

onMounted(() => {
    authStore.setEauthToken();
});
</script>

<template>
    <GlobalToast/>

    <MenuLateral/>

    <div class="app-container">
        <BarraSuperior :height="barraSuperiorHeight"/>

        <main class="main-content">
<!--            <BarraLateral :top="barraSuperiorHeight"/>-->

            <slot/>
        </main>
    </div>
</template>

<style scoped>
.app-container {
    height: 100vh;
    min-height: 100vh;
    width: 100vw;
    min-width: 100vw;
    display: flex;
    flex-direction: column;
}

.main-content {
    width: 100vw;
    max-width: 100vw;
    min-height: 0;
    display: flex;
    flex: 1;
}
</style>
